/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createContext, useCallback, useContext } from 'react';

import { useToast } from '~/common/providers/toast';
import { useAuth } from '~/common/providers/auth';
import { IFCWithChildren } from '~/common/interfaces/i-fc-with-childrent';
import { api } from '~/common/api';

type SavedPromptsContextData = {
  savePrompt: (promptId: string) => Promise<void>;
  unsavePrompt: (promptId: string) => Promise<void>;
};

const SavedPromptsContext = createContext({} as SavedPromptsContextData);

const SavedPromptsProvider: IFCWithChildren = ({ children }) => {
  const { includeSavedPrompts, excludeSavedPrompts } = useAuth();

  const { showToast } = useToast();
  const savePrompt = useCallback(
    async (promptId: string) => {
      try {
        await api
          .post(`/saved-prompts/${promptId}`)
          .then(() => includeSavedPrompts(promptId));
      } catch {
        showToast({
          severity: 'error',
          title: 'Erro',
          description:
            'Não foi possível salvar o prompt. Tente novamente mais tarde.',
        });
      }
    },
    [showToast, includeSavedPrompts]
  );

  const unsavePrompt = useCallback(
    async (promptId: string) => {
      try {
        await api
          .delete(`/saved-prompts/${promptId}`)
          .then(() => excludeSavedPrompts(promptId));
      } catch {
        showToast({
          severity: 'error',
          title: 'Erro',
          description:
            'Não foi possível remover o prompt salvo. Tente novamente mais tarde.',
        });
      }
    },
    [showToast, excludeSavedPrompts]
  );

  return (
    <SavedPromptsContext.Provider value={{ savePrompt, unsavePrompt }}>
      {children}
    </SavedPromptsContext.Provider>
  );
};

const useSavedPrompts = () => useContext(SavedPromptsContext);

export { SavedPromptsProvider, useSavedPrompts };
